import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function customEmailValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const emailRegEx = /^(?!_)[a-zA-Z0-9_.%+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-]{2,}$/;
    const valid = emailRegEx.test(control.value);
    return valid ? null : { invalidEmail: true };
  };
}
